import React from "react";
import slicer from "./sclicer";
import createLink from "../createLink";
import {Link} from "react-router-dom";
import {isExternalLink} from "../helper";


const mentionDecorator = {
    render : (key, text, data)=>{
        return (
            <Link key={key} to={createLink('userProfile', data.user)} rel="noopener noreferrer" className={"mentionned-name"}>
                {data?.user?.username ? `@${data?.user?.username}`: text}
            </Link>
        )
    }
}

const linkDecorator = {
    render : (key, text, data)=>{
        const { isExternal, path } = isExternalLink(data.url);

        if(!isExternal){
            data.target = "_self";
            data.rel = "";
        }
        return (
            <Link key={key} to={isExternal ? data.url : path} target={data.target || "_blank"} rel={data.rel || ""} className={"linked"} state={{from : window.location.href}} >
                {text}
            </Link>
        )
    }
}

const extensions = {
    mention : mentionDecorator,
    link : linkDecorator
}
const Reader = ({text = "", meta = {}}) =>{
    let metas = [];
    if (Object.keys(meta).length === 0) return text;
    else {
        Object.keys(meta).forEach(key=>{
            if(Array.isArray(meta[key])){
                metas.push(...meta[key].map(({offset, length, ...data})=>({
                    type : key,
                    offset,
                    length,
                    data
                })))
            }
        });
        let {sliced, hasMetas} = slicer(text, metas);
        if (hasMetas) {
            let children = sliced.map((slice, i)=>{
                return (slice.isMeta && slice.type in extensions) ? extensions[slice.type].render(i, slice.text, slice.data) : slice.text
            });
            return (
                <span children={children}/>
            )
        }
        else return text;
    }
}

export default Reader;